import { FC } from 'react';

import { SectionBody } from '@portal/common/components';
import { styled } from '@portal/common/theme';

import _ from '../../../locale/_';

type Props = {};

const StyledSectionBody = styled(SectionBody)(({ theme }) => ({
    padding: '15px !important',
    [theme.breakpoint.md]: {
        padding: '50px 30px 50px 30px !important',
    },
}));

const LocationDefinitionsSection: FC<Props> = ({}) => (
    <StyledSectionBody>{_('ght_location_definitions_text')}</StyledSectionBody>
);

export default LocationDefinitionsSection;
